/**
 * @see https://doc.babylonjs.com/how_to/optimizing_your_scene#changing-mesh-culling-strategy
 */
export var Strategy;

(function (Strategy) {
  Strategy[Strategy["Standard"] = 0] = "Standard";
})(Strategy || (Strategy = {}));

var Cullable =
/** @class */
function () {
  function Cullable() {
    this.strategy = Strategy.Standard;
    this.visibilityPlaneMask = -1;
    this.visible = true;
    this.enable = true;
  }

  Cullable.prototype.isCulled = function () {
    return this.enable && !this.visible;
  };

  Cullable.tag = 'c-cullable';
  return Cullable;
}();

export { Cullable };